import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { PortalModule } from '@angular/cdk/portal';

import { PillarModule } from '../pillar/pillar.module';
import { frameRoutes } from './routes.config';
import { UserAccountComponent } from './user-account/user-account.component';
import { CoreModule } from '../core/core.module';

@NgModule({
  entryComponents: [],
  declarations: [UserAccountComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule.forChild(frameRoutes),
    PortalModule,
    PillarModule,
    CoreModule
  ],
  exports: [],
  providers: []
})
export class FramesModule {
}



// WEBPACK FOOTER //
// ./src/app/frames/frames.module.ts